import React from 'react';
import CallToAction from 'components/CallToAction';
import Hero from 'containers/Products/Hero';
import { ReactComponent as BettingHero } from "assets/svg/products/betting-hero.svg"
import { ReactComponent as ArrowRight } from "assets/svg/products/arrow-right-feat.svg"
import { ReactComponent as Compass } from "assets/svg/products/compass-feat.svg"
import { ReactComponent as Secure } from "assets/svg/products/secure-feat.svg"
import { ReactComponent as Ease } from "assets/svg/products/ease-feat.svg"
import Steps from 'containers/Products/Steps';
import Card from 'containers/Products/Steps/Card';
import FAQ from 'containers/Products/FAQ';
import { betting_faq } from 'constants/faq';
import Feature from 'containers/Products/Feature';
import { Helmet } from 'react-helmet-async';
import { POUCHERS_WEBSITE_URL, POUCHERS_LOGO_URL } from 'constants';




export default function Betting() {
    return (
        <>
            <Helmet>
                <meta name='title' content="Fund Your Betting Account in Seconds - Pouchers" />
                <meta name="description" content="With Pouchers, it only takes seconds to fund your betting accounts. We support all major betting platforms in Nigeria. What are you waiting for?" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${POUCHERS_WEBSITE_URL}/products/betting`} />
                <meta property="og:title" content="Fund Your Betting Account in Seconds - Pouchers" />
                <meta property="og:description" content="With Pouchers, it only takes seconds to fund your betting accounts. We support all major betting platforms in Nigeria. What are you waiting for?" />
                <meta property="og:image" content={POUCHERS_LOGO_URL} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content={`${POUCHERS_WEBSITE_URL}/products/betting`} />
                <meta name="twitter:title" content="Fund Your Betting Account in Seconds - Pouchers" />
                <meta name="twitter:description" content="With Pouchers, it only takes seconds to fund your betting accounts. We support all major betting platforms in Nigeria. What are you waiting for?" />
                <meta name="twitter:image" content={POUCHERS_LOGO_URL} />
                <title>Fund Your Betting Account in Seconds - Pouchers</title>
            </Helmet>
            <div className="bg-[#5034C40D]">
                <Hero
                    title={<span>Instantly Fund Your <span className='text-purple'>Online Sports Betting Account</span></span>}
                    description="Say goodbye to long waiting times and complicated payment processes. With Pouchers, you can instantly and conveniently deposit funds into your betting account without any fuss."
                    image={<BettingHero className="max-w-[284px] sm:max-w-[356px] h-[389px] sm:h-[489px]" />}
                    buttonName="Fund Betting Wallet"
                />
            </div>
            <Steps
                title={
                    <h1 className="text-dark text-32 sm:text-36 font-altone_b leading-[40px] sm:leading-[44px] mb-[24px]">
                        How To Fund Betting Account Through <span className='text-green'>Pouchers</span>
                    </h1>
                }
                description="With Pouchers, you can enjoy the convenience of accessing your account whenever and wherever you want without the stress of logging in. Get started today and experience the freedom of no login access."
            >
                <div className='grid gap-[16px]'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-[16px]'>
                        <Card
                            step="01"
                            description={<>Visit the Pouchers website or download the Pouchers mobile app.</>}
                        />
                        <Card
                            step="02"
                            description={<>Create an account or sign up on Pouchers</>}
                        />
                        <Card
                            step="03"
                            description={<>Select the <span className='text-purple font-dmsans_b'>'Betting'</span> option from the main menu.</>}
                        />
                        <Card
                            step="04"
                            description={<>Choose the <span className='text-purple font-dmsans_b'>'betting platform'</span> you want to fund, such as Bet9ja, Nairabet, or 1960Bet.</>}
                        />
                        <Card
                            step="05"
                            description={<><span className='text-purple font-dmsans_b'>Enter the amount </span>you want to fund your account with and confirm the transaction.</>}
                        />
                        <Card
                            step="06"
                            description={<>Enter your <span className='text-purple font-dmsans_b'>customer ID</span>. Your customer ID is always available on your betting account.</>}
                        />
                    </div>
                    <Card
                        step="07"
                        description='Pouchers will automatically fetch the name associated with the customer ID.'
                    />
                    <Card
                        step="08"
                        description={
                            <>
                                <span className='text-purple font-dmsans_b'>Confirm the details </span>and complete the betting funding with your <span className='text-purple font-dmsans_b'>preferred payment method</span>.
                                If you aren’t logged in on Pouchers, you can pay with either debit card or bank account. If you’re logged in, you'll pay from your Pouchers wallet.
                            </>
                        }
                    />
                    <Card
                        step="09"
                        description='Once your transaction is confirmed, your betting account will be credited with the amount you funded.'
                    />
                </div>
            </Steps>
            <div className='py-[48px] grid sm:grid-cols-2'>
                <Feature
                    icon={<Secure />}
                    className='bg-[#FFFAE6]'
                    title='Secure and Reliable'
                    description={`Trust is key when it comes to betting. That's why we've built Pouchers with the latest security measures to ensure your payment details are always kept safe.`}
                />
                <Feature
                    icon={<Ease />}
                    className='bg-[#EFE7F7]'
                    title='Enjoy Ease'
                    description={`No matter where you are, you can easily fund your betting account with Pouchers. All you need is an internet connection and you're good to go.`}
                />
                <Feature
                    icon={<Compass />}
                    className='bg-[#E7F5FF]'
                    title='Multiple Betting Platforms Supported'
                    description={`Including 1960Bet, Bonanza Win, Betway, Bet9ja, Nairabet, 1xBET, MelBet, Livescore Bet, Bettika, Bangbet, Betbiga, Koretbet, Premier Lotto E.T.C and more.`}
                />
                <Feature
                    icon={<ArrowRight />}
                    className='bg-[#FFFFFF]'
                    title={`It's that easy to fund your betting account on Pouchers.`}
                />
            </div>
            <FAQ type="funding your bet account" questions={betting_faq} />
            {/* <CallToAction
                title="All you need to run your finances effectively"
                description="Ready to take control of your finances? Join the Pouchers revolution today and experience the benefits of a simplified payment system."
            /> */}
        </>
    );
};